module.exports = __webpack_public_path__ + "static/media/Reports.f645a328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NavIcons/Reports.png
// module id = 593
// module chunks = 0